import { useEffect, useState, useMemo } from "react";
import { Row, Container, Button, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import EditModal from "./EditModal";
import RemoveModal from "./RemoveModal";

import toastService from "../../_services/toastService";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function BudgetSources() {
  const snapshot = useSelector(state => state.snapshot.fileName);

  const [budgetSources, setBudgetSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editModal, setEditModal] = useState(null);
  const [removeModal, setRemoveModal] = useState(null);

  const loadBudgetSources = async () => {
    try {
      setLoading(true);
      const sources = await api.getBudgetSources(snapshot);
      sources.sort((a, b) => a.name.localeCompare(b.name));
      setBudgetSources(sources);
      setLoading(false);
    } catch (error) {
      toastService.send({ title: "An error occured", message: `${error}` });
      setLoading(false);
    }
  };

  const openEditModal = budgetSource => {
    setEditModal(
      <EditModal
        hideModal={() => {
          setEditModal(null);
          loadBudgetSources();
        }}
        data={budgetSource}
      />,
    );
  };

  const openRemoveModal = budgetSource => {
    setRemoveModal(
      <RemoveModal
        hideModal={() => {
          setRemoveModal(null);
          loadBudgetSources();
        }}
        data={budgetSource}
      />,
    );
  };

  const gridStyle = { minHeight: 550 };

  const columns = useMemo(() => [
    { name: 'name', header: 'Naam', defaultFlex: 1 },
    {
      name: 'ID', header: 'Acties', defaultFlex: 1, draggable: false, sortable: false,
      render: ({ data }) => (
        <div>
          <Button variant="info" onClick={() => openEditModal(data)} disabled={snapshot}>
            <i className="far fa-edit" />
          </Button>
          <Button variant="danger" onClick={() => openRemoveModal(data)} disabled={snapshot}>
            <i className="far fa-trash" />
          </Button>
        </div>
      )
    }
  ], [snapshot]);

  const filterValue = [
    { name: 'name', operator: 'contains', type: 'string', value: '' },
  ];

  useEffect(() => {
    loadBudgetSources();
  }, [snapshot]);

  if (loading) {
    return (
      <div className="text-center">
        <i className="fad fa-spinner-third fa-spin fa-5x" />
      </div>
    );
  }

  return (
    <Container>
      {editModal}
      {removeModal}
      <Row>
        <h1>Budgetbronnen</h1>
      </Row>
      <Row className="my-2">
        <Col className="text-end">
          <Button variant="success" onClick={() => openEditModal()} disabled={snapshot}>
            <i className="far fa-plus" />
            &nbsp;Nieuw
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <ReactDataGrid
            idProperty="ID"
            style={gridStyle}
            defaultFilterValue={filterValue}
            columns={columns}
            dataSource={budgetSources}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default BudgetSources;
